export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/LocationNotAllowed.d7692b40.svg","height":37,"width":29,"blurWidth":0,"blurHeight":0};